import { DSInput } from "@components/design-system/molecules";
import { useController } from "react-hook-form";

export function AdditionalFieldInput({
  fieldName,
  control,
  title,
  placeholder = null,
}) {
  const { field } = useController({
    name: fieldName,
    control,
  });
  return (
    <div className="my-sm">
      <h4 className="text-gray-600 dark:text-gray-300">{title}</h4>
      <DSInput
        placeholder={placeholder}
        value={field.value ?? ""}
        onChange={(e) => field.onChange(e.target.value)}
        onBlur={field.onBlur}
        dataTestId={`${fieldName}-input`}
      />
    </div>
  );
}
